import * as React from 'react';
import PropTypes from 'prop-types';
import { InputNumber } from 'mkui-fd';
import classNames from 'classnames';

export default class CurrencyInput extends React.Component {
  static propTypes = {
    prefixCls: PropTypes.string,
    precision: PropTypes.number,
    symbol: PropTypes.string,
    disabled: PropTypes.bool,
    nonnegative: PropTypes.bool,
    onChange: PropTypes.func,
    value: PropTypes.number,
    theme: PropTypes.string,
    onBlur: PropTypes.func,
  };

  static defaultProps = {
    prefixCls: 'mk-currency-input',
    precision: 2,
    symbol: '',
    disabled: false,
    nonnegative: false,
    value: 0,
    theme: undefined,
    onChange: () => {
    },
    onBlur: () => {
    },
  };

  static allSymbol = ['￥', '$', '€', '￡'];

  static getSymbol(symbol) {
    return symbol === 'CNY' ? '￥' : symbol;
  }

  changeHandle = (number) => {
    const { onChange } = this.props;
    onChange(number);
  }

  blurHandle = (e) => {
    const { onBlur } = this.props;
    const value = Number(this.parser(e.target.value));
    onBlur(value, e);
  }

  formatter = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  parser = (value) => {
    const reg = new RegExp(',', 'g');
    return value.replace(reg, '');
  }

  render() {
    const { prefixCls, precision, symbol, placeholder, disabled, value, theme, nonnegative } = this.props;
    const isSymbol = CurrencyInput.allSymbol.includes(symbol);
    const rootCls = {
      [prefixCls]: 1,
      text: !isSymbol,
      symbol: isSymbol,

    };
    const s = CurrencyInput.getSymbol(symbol);
    return (
      <div className={classNames(rootCls)}>
        <span className={`${prefixCls}-symbol`}>{s}</span>
        <InputNumber
          max={999999999999999}
          min={nonnegative ? 0 : undefined}
          value={value}
          placeholder={placeholder}
          precision={precision}
          disabled={disabled}
          onChange={this.changeHandle}
          className="mk-currency-input-number"
          formatter={(formattervalue) => this.formatter(formattervalue)}
          parser={(parseValue) => this.parser(parseValue)}
          theme={theme}
          onBlur={this.blurHandle}
        />
      </div>
    );
  }
}
